import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  errorDownload: {
    id: 'Message.errorDownload',
    description: 'Error download',
    defaultMessage: 'Kunde inte ladda ner filen',
  },
});
